import { msgExpireDurationOptions } from '@/configs/options';
import styles from './index.module.scss';
import VectorIcon from './images/vector.svg?react';
import type { MyAvatarProps } from './type';
import { TagTypes } from './type';

const MyAvatar = ({
  className,
  size = 'medium',
  src,
  tagType,
  expireDuration,
  onClick,
}: MyAvatarProps) => {
  const TagTypesData = useMemo(
    () => ({
      [TagTypes.DESTROY]:
        expireDuration &&
        msgExpireDurationOptions.findByValue(expireDuration)?.avatarIcon,
      [TagTypes.VECTOR]: <VectorIcon />,
    }),
    [expireDuration]
  );

  const myAvatarCls = {
    [styles.small]: size === 'small',
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.hoverable]: !!onClick,
    [className as string]: className,
  };
  return (
    <div className={cls(styles.myAvatar, myAvatarCls)} onClick={onClick}>
      <img src={src} alt="avatar" crossOrigin="anonymous" />
      {tagType && <div className={styles.tag}>{TagTypesData[tagType]}</div>}
    </div>
  );
};
export default MyAvatar;
